<template>
    <div id="dealer-page">
        <section-definition
                :title="page.title"
        >
        </section-definition>

        <my-show-error
                v-model="dialog_show_error"
                :error="show_error_obj"
        ></my-show-error>

        <!--<section-definition-->
                <!--:title="page.title"-->
                <!--:menuItems="menuItems"-->
                <!--:refresh_fn="get_users"-->
        <!--&gt;-->
        <!--</section-definition>-->

        <!--Pop up dialog for editing ***********************************************************************-->
        <v-dialog v-model="dialog" persistent max-width="700px" attach="#dealer-page">
            <!--<template v-slot:activator="{ on }">-->
                <!--<v-btn color="primary" dark class="mb-2" v-on="on">Add User</v-btn>-->
            <!--</template>-->
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form">
                        <v-container fluid grid-list-md page fill-height>
                            <v-layout wrap >

                                <v-flex xs12 sm5 md5>
                                    <v-autocomplete
                                            v-if="$auth.profile.user_role === 'SuperAdmin'"
                                            :items="agencies"
                                            label="Agency"
                                            item-value="_id"
                                            item-text="name"
                                            v-model="editedItem.agency_id"
                                            :rules="[x => isRequired(x, 'Agency')]"
                                    >
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex md7></v-flex>


                                <v-flex xs12 sm5 md5 v-if="$auth.profile.acct_type==='AGENCY'">
                                    <v-autocomplete
                                            :items="[{txt: 'Agency', value: 'AGENCY'}, {txt: 'Client', value: 'CLIENT'}]"
                                            label="Account Type*"
                                            item-value="value"
                                            item-text="txt"
                                            v-model="editedItem.acct_type"
                                            v-on:change="on_acct_change"
                                            :rules="[x => isRequired(x, 'Account type')]"
                                    >
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm5 md5 v-else>
                                    <v-autocomplete
                                            :items="[{txt: 'Client', value: 'CLIENT'}]"
                                            label="Account Type*"
                                            item-value="value"
                                            item-text="txt"
                                            v-model="editedItem.acct_type"
                                            v-on:change="on_acct_change"
                                            :rules="[x => isRequired(x, 'Account type')]"
                                    >
                                    </v-autocomplete>
                                </v-flex>




                                <v-flex xs6 sm6 md3>
                                    <v-select
                                            :items="[{text:'Yes', value:true}, {text:'No', value:false}]"
                                            label="Account Active?"
                                            v-model="editedItem.is_active"
                                            item-value="value"
                                            item-text="text"
                                            required
                                    ></v-select>
                                </v-flex>


                                <v-flex md4></v-flex>

                                <v-flex xs12 sm4 md4>
                                    <v-autocomplete
                                            :items="userRoles"
                                            label="User's Role*"
                                            v-model="editedItem.role"
                                            v-on:change="on_role_change"
                                            :rules="[x => isRequired(x, 'Role')]"
                                            no-data-text="Please Account Type"
                                    >
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm4 md4>
                                    <v-combobox
                                            :items="user_titles"
                                            label="Title*"
                                            v-model="editedItem.title"
                                            :disabled="disable_title"
                                            :rules="[x => isRequired(x, 'Title', disable_title)]"
                                            no-data-text="Please select Role"
                                    >
                                    </v-combobox>

                                </v-flex>
                                <v-flex xs12 sm4 md4 >
                                    <v-autocomplete
                                        label="Curriculum Level"
                                        :items="userLevels"
                                        item-text="txt"
                                        item-value="value"
                                        v-model="editedItem.sp_level"
                                        :disabled="disable_sp_level"
                                        :rules="[x => isRequired(x, 'Level', disable_sp_level_validation)]"
                                    >
                                        <v-tooltip slot="append-outer" bottom>
                                            <v-icon slot="activator" >help</v-icon>
                                            <span>Tooltip</span>
                                        </v-tooltip>
                                    </v-autocomplete>
                                </v-flex>

                                <v-flex xs12 sm9 md10>
                                    <v-autocomplete
                                        :items="organizations"
                                        label="Organization*"
                                        item-value="_id"
                                        item-text="name"
                                        v-on:change="on_org_change"
                                        v-model="editedItem.org_ids"
                                        :multiple="multiple_orgs"
                                        :disabled="disable_orgs"
                                        :rules="[x => isRequired(x, 'Organization', disable_orgs)]"
                                    ></v-autocomplete>
                                </v-flex>

                                <v-flex xs12 sm3 md2>
                                    <v-checkbox
                                        label="Enable"
                                        v-model="enable_org_change"
                                        :disabled="disable_orgs_check"
                                    ></v-checkbox>
                                </v-flex>

                                <v-flex xs12 sm9 md10>
                                    <v-autocomplete
                                        :items="dealers"
                                        label="Dealership(s)*"
                                        item-value="_id"
                                        item-text="name"
                                        no-data-text="Please select Organization"
                                        v-model="editedItem.dealership_ids"
                                        multiple
                                        :disabled="disable_dealer_select"
                                        :rules="[x => isRequired(x, 'Dealership', disable_dealer_select)]"
                                    ></v-autocomplete>
                                </v-flex>

                                <v-flex xs12 sm3 md2>
                                    <v-checkbox
                                        label="Enable"
                                        v-model="enable_dealer_change"
                                        :disabled="disable_dealer_check"
                                    ></v-checkbox>
                                </v-flex>

                                <v-flex xs12 sm6 md6>
                                    <v-text-field
                                            label="First Name*"
                                            v-model="editedItem.name_first"
                                            :rules="[x => isRequired(x, 'First name')]"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field
                                            label="Last Name*"
                                            v-model="editedItem.name_last"
                                            :rules="[x => isRequired(x, 'Last name')]" ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12 pb-0 mb-0>
                                    <v-text-field
                                            label="Email*"
                                            :rules="[x => checkEmail(x) ]"
                                            v-model="editedItem.email"
                                    ></v-text-field>

                                </v-flex>


                                <v-flex xs12 sm8 md8 v-if="newUser">
                                    <v-text-field
                                            label="Password*"
                                            :type="showpass ? 'text' : 'password'"
                                            :append-icon="showpass ? 'visibility' : 'visibility_off'"
                                            hint="At least 8 characters"
                                            :rules="[validationRules.required, validationRules.min]"
                                            counter
                                            @click:append="showpass = !showpass"
                                            v-model="editedItem.password"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs4 sm8 md4 v-if="newUser">
                                    <v-btn v-on:click="gen_password_checked(12)">
                                        Gen Password
                                    </v-btn>
                                </v-flex>


                               <!--<div style="font-size: 13pt; font-weight: 600; color: gray">-->
                               <!--   Emails/Reporting Settings-->
                               <!--</div>-->


                               <!--<v-flex xs12 pt-0 mt-0 >-->
                               <!--   <v-checkbox-->
                               <!--       label="Monthly Enterprise PDF Reports"-->
                               <!--       v-model="editedItem.include_on_pdf_reports_org"-->
                               <!--       color="primary"-->
                               <!--       height="10"-->
                               <!--       hide-details-->
                               <!--       :disabled="isSalesPerson"-->
                               <!--   ></v-checkbox>-->
                               <!--</v-flex>-->

                               <!-- <v-flex xs12 pt-0 mt-0 >-->
                               <!--     <v-checkbox-->
                               <!--             label="Monthly Dealer PDF Reports"-->
                               <!--             v-model="editedItem.include_on_pdf_reports"-->
                               <!--             color="primary"-->
                               <!--             height="10"-->
                               <!--             hide-details-->
                               <!--             :disabled="isSalesPerson"-->
                               <!--     ></v-checkbox>-->
                               <!-- </v-flex>-->

                               <!--<v-flex xs12 pt-0 mt-0 >-->
                               <!--   <v-checkbox-->
                               <!--       label="Monthly Individual PDF Reports"-->
                               <!--       v-model="editedItem.include_on_pdf_reports_sp"-->
                               <!--       color="primary"-->
                               <!--       height="10"-->
                               <!--       hide-details-->
                               <!--       :disabled="disable_pdf_reports"-->
                               <!--   ></v-checkbox>-->
                               <!--</v-flex>-->


                               <!--<v-flex xs12 pt-0 mt-0>-->
                               <!--   <v-checkbox-->
                               <!--       label="Individual Grading Emails"-->
                               <!--       v-model="editedItem.include_on_grades"-->
                               <!--       color="primary"-->
                               <!--       height="10"-->
                               <!--       hide-details-->
                               <!--       pt-0 pb-0 mt-0 mb-0-->
                               <!--       class="my-custom-no-padding"-->
                               <!--       :disabled="disable_include_on_grades"-->
                               <!--   ></v-checkbox>-->
                               <!--</v-flex>-->
                               <!-- <v-flex xs12 pt-0 mt-0 >-->
                               <!--     <v-checkbox-->
                               <!--             label="Internal Grading Comments"-->
                               <!--             v-model="editedItem.include_on_comments_internal"-->
                               <!--             color="primary"-->
                               <!--             height="10"-->
                               <!--             hide-details-->
                               <!--             :disabled="disable_comments_internal"-->
                               <!--     ></v-checkbox>-->
                               <!-- </v-flex>-->



                               <!--<v-flex xs12 pt-0 mt-0 >-->
                               <!--   <v-checkbox-->
                               <!--       label="Monthly CoachUp Emails"-->
                               <!--       v-model="editedItem.include_on_pdf_reports_coachup"-->
                               <!--       color="primary"-->
                               <!--       height="10"-->
                               <!--       hide-details-->
                               <!--       :disabled="disable_pdf_reports"-->
                               <!--   ></v-checkbox>-->
                               <!--</v-flex>-->


                               <!--<v-flex xs12 pt-0 mt-0 >-->
                               <!--   <v-checkbox-->
                               <!--       label="CoachUp Emails"-->
                               <!--       v-model="editedItem.include_on_coachup"-->
                               <!--       color="primary"-->
                               <!--       height="10"-->
                               <!--       hide-details-->
                               <!--       :disabled="disable_pdf_reports"-->
                               <!--   ></v-checkbox>-->
                               <!--</v-flex>-->





                            </v-layout>

                        </v-container>
                    </v-form>



                   <div style="font-size: 13pt; font-weight: 600; color: gray; margin-left: 10px;">
                      Emails/Reporting Settings
                   </div>
                   <v-layout row pt-0 mt-0 style="margin-left: 15px">
                      <v-flex pt-0 mt-0 >
                         <v-checkbox
                             label="Monthly Enterprise PDF Reports"
                             v-model="editedItem.include_on_pdf_reports_org"
                             color="primary"
                             height="10"
                             hide-details
                             :disabled="isSalesPerson"
                         ></v-checkbox>


                         <v-checkbox
                             label="Monthly Dealer PDF Reports"
                             v-model="editedItem.include_on_pdf_reports"
                             color="primary"
                             height="10"
                             hide-details
                             :disabled="isSalesPerson"
                         ></v-checkbox>


                         <v-checkbox
                             label="Monthly Individual PDF Reports"
                             v-model="editedItem.include_on_pdf_reports_sp"
                             color="primary"
                             height="10"
                             hide-details
                             :disabled="disable_pdf_reports"
                         ></v-checkbox>


                         <v-checkbox
                             label="Individual Grading Emails"
                             v-model="editedItem.include_on_grades"
                             color="primary"
                             height="10"
                             hide-details
                             pt-0 pb-0 mt-0 mb-0
                             class="my-custom-no-padding"
                             :disabled="disable_include_on_grades"
                         ></v-checkbox>


                      </v-flex>


                      <v-flex  pt-0 mt-0 mb-5>
                         <v-checkbox
                             label="Monthly CoachUp PDF Reports"
                             v-model="editedItem.include_on_pdf_reports_coachup"
                             color="primary"
                             height="10"
                             hide-details
                             :disabled="isSalesPerson"
                         ></v-checkbox>

                         <v-checkbox
                             label="Individual CoachUp Emails"
                             v-model="editedItem.include_on_coachup"
                             color="primary"
                             height="10"
                             hide-details
                             :disabled="disable_pdf_reports"
                         ></v-checkbox>

                         <hr style="margin-top: 20px">
                         <v-checkbox
                             label="Internal Grading Comments"
                             v-model="editedItem.include_on_comments_internal"
                             color="primary"
                             height="10"
                             hide-details
                             :disabled="disable_comments_internal"
                         ></v-checkbox>
                      </v-flex>
                   </v-layout>




                    <v-layout row v-if="form_error">
                        <!--<v-flex grow></v-flex>-->
                        <v-spacer></v-spacer>
                        <v-flex shrink class="pr-3 red--text"> {{form_error}}</v-flex>

                    </v-layout>


                </v-card-text>



                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="close">Cancel</v-btn>
                    <v-btn color="primary" @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> <!-- end Pop up dialog for editing *****************************************************-->






        <!----------------dialog for global user search---------------------------------------------------------------->
        <v-dialog v-model="dialog_search" persistent max-width="500px" attach="#dealer-page">
            <v-card>
                <v-progress-linear v-if="is_searching" :indeterminate="true" color="primary"></v-progress-linear>
                <v-card-text>
                    <v-layout>

                        <v-flex>
                            <v-text-field
                                    label="User's Email Address"
                                    v-model="g_search_txt"
                                    v-on:keyup.enter="get_users_search"
                                    ref="global_search_box"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    For partial matches use a <span style="font-size:medium;">*</span>. For example,
                    "*taskteacher.com" will return all users with an
                    email ending in "taskteacher.com", while "john*" will return all users with an email starting with "john"
                </v-card-text>



                <v-layout row v-if="form_error_search">
                    <!--<v-flex grow></v-flex>-->
                    <v-spacer></v-spacer>
                    <v-flex shrink class="pr-3 red--text"> {{form_error_search}}</v-flex>
                </v-layout>



                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn color='accent' @click="dialog_search=false">Cancel</v-btn>
                    <v-btn color='accent' :disabled="is_searching" @click="get_users_search">Search</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>







        <!--------------------main page content---------------------------------------------------------------------->
        <v-container fluid grid-list-xs page>
            <!--header controls*********************************************************************************-->
            <v-layout  align-baseline>
                <v-flex shrink>
                    <v-btn color="primary" dark class="mb-2" v-on:click="new_user">Add User</v-btn>
                </v-flex>
                <v-flex shrink>
                    <v-btn @click="download_users" color="accent">Download</v-btn>
                </v-flex>
                <v-flex shrink>
                    <v-switch
                            v-model="showOnlyActive"
                            :label="'Only Active Accounts'"
                            color="primary"
                            v-on:change="get_users_local(); update_orgs_main()"
                    ></v-switch>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink  align-self-end class="mb-3 mr-3" v-if="$auth.profile.acct_type==='AGENCY'">
                    <v-layout @click="open_g_search" style="cursor:pointer;">
                        <v-icon medium>search</v-icon>
                        <div>Global Search</div>
                    </v-layout>
                </v-flex>
                <v-flex xs2>
                    <v-text-field
                            v-model="search_txt"
                            append-icon="search"
                            label="Local Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-flex>

                <v-flex xs2>
                    <v-autocomplete
                            class="pl-3"
                            :items="orgs2"
                            item-value="_id"
                            item-text="name"
                            v-model="selectedOrg"
                            label="Select Org"
                            v-on:change="on_org_change_main"
                            hide-details
                    ></v-autocomplete>
                </v-flex>

                <v-flex xs2>
                    <v-autocomplete
                            class="pl-3"
                            :items="dealers_main"
                            item-value="_id"
                            item-text="name"
                            v-model="selectedDealerId"
                            label="Select Dealership"
                            v-on:change="get_users_local"
                            hide-details
                    ></v-autocomplete>
                </v-flex>




                <!--<v-flex shrink class="center-align">-->
                    <!--<v-icon @click="dialog_search=true">search</v-icon>-->
                    <!--<div>Global Search</div>-->
                <!--</v-flex>-->

            </v-layout>


            <!--------------------main data table--------------------------------------------->
            <v-data-table
                :headers="headers"
                :items="users"
                :search="search_txt"
                :rows-per-page-items="pagination"
                :pagination.sync="pagination_settings"
                class="elevation-1 border-radius6"
                :loading="getting_users"
            >
                <template slot="items" slot-scope="props" >
                    <!--<tr class="row" @click="editItem(props.item)">-->
                    <tr v-bind:class="get_row_class(props.item.app_metadata.is_active)"
                        class="row"
                        @click="editItem(props.item)"
                        :key="props.item.user_id"
                    >
                        <td>
                            <v-avatar slot="activator" size="40">
                                <img :src="props.item.picture">
                            </v-avatar>
                        </td>
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.app_metadata.acct_type}}</td>
                        <td>{{ props.item.app_metadata.role}}</td>
                        <!--<td>{{ props.item.app_metadata.org_ids.length>0? props.item.app_metadata.org_ids[0].name: 'N/A'}}</td>-->
                        <td>{{ props.item.app_metadata.org_ids[0]? props.item.app_metadata.org_ids[0].name: 'N/A'}}</td>
                        <td>{{ props.item.email }}</td>
                        <td>{{ props.item.app_metadata.is_active ? 'Yes' : 'No' }}</td>
                        <td >{{props.item.last_login ? fmt_datetime(props.item.last_login) : 'Never Logged In'}}</td>
                        <!--<td class="justify-center">-->
                            <!--<v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>-->
                            <!--&lt;!&ndash;<v-icon small @click="deleteItem(props.item)"> delete </v-icon>&ndash;&gt;-->
                        <!--</td>-->
                    </tr>

                </template>
                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search_txt }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>

        </v-container>


    </div>
</template>

<style scoped>
    .row_inactive {
        color: #b8b8b8;
    }
    .error_txt{
        color: red;
    }

    .row{
        cursor: pointer;
    }
</style>

<script>
   import data_getters from '../mixins/data_getters'
   import validate from '../mixins/validation'
   import axios from 'axios';


   const form =  {
      agency_id: '',
      org_ids: [],
      dealership_ids: [],
      name_first: '',
      name_last: '',
      role: '',
      title: 'n/a',
      acct_type: '',
      email: '',
      include_on_grades: false,
      include_on_pdf_reports: false,
      include_on_comments_internal: null,
      password: '',
      sp_level: '',
      is_active: true,
   };



   export default {
      mixins: [data_getters, validate],
      data() {
         return {
            // agency_id: '5d5dd685713218da7085bc81', //dealerknows
            //data for dealers list
            headers: [
               {text: '', value: 'avatar'},
               {text: 'User', value: 'name'},
               {text: 'Acct Type', value: 'app_metadata.acct_type'},
               {text: 'Role', value: 'app_metadata.role'},
               {text: 'Organization', value: 'app_metadata.org_ids.name'},
               {text: 'Email', value: 'email'},
               {text: 'Active', value: 'app_metadata.is_active'},
               {text: 'Last Login', value:"last_login" },
            ],
            users: [],
            pagination: [25, 50, 100, {"text":"All","value":-1}],
            pagination_settings: {
               sortBy: 'name', // The field that you're sorting by
               descending: false,
               rowsPerPage: 25
            },
            showOnlyActive: true,

            selectedOrg: null,
            selectedDealerId: null,


            // organization/dealer data********************************************
            agencies: [],
            organizations: [],
            orgs2: [],       // holds orgs for the page dropdown

            dealers: [], //used by form to hold dealers to add user to
            dealers_main: [], //holds list of dealer for the page dropdown

            multiple_orgs: false, // used to indicated user can select multiple orgs or not
            form_error: null,

            enable_org_change: true,
            enable_dealer_change: true,

            //search bar
            search_txt: '',

            getting_users: false,

            //add new/edit dialog********************************************
            formTitle: 'Add New User',
            dialog: false,
            showpass: false,
            newUser: true, // used to signal if we're adding a new user or editing an existing one
            errorMsg: false,
            editedIndex: -1,
            editedItem: JSON.parse(JSON.stringify(form)),//  Object.assign({}, form),

            userRoles: [],
            // userRoles_a: ['SuperAdmin', 'Admin', 'Grader', 'AcctManager'],
            userRoles_a: ['Admin',  'AcctManager', 'Grader'],
            userRoles_c: ['Admin', 'Executive',  'Manager', 'SalesPerson'],
            userLevels: [
               {txt:'Basic', value:'1'},
               {txt:'Bachelor', value:'2'},
               {txt:'Master', value:'3'},
               {txt:'PhD', value:'4'},
            ],
            validationRules: {
               required: value => !!value || 'Required.',
               min: v => {
                  if (v !== undefined && v.length >= 8){
                     return true;
                  }
                  else
                  {return 'Min 8 characters';}
               },
               password: {}

            },

            //global search variables
            dialog_search: false,
            g_search_txt: '',
            form_error_search: null,
            is_searching: false,



            //main page header********************************************
            page: {
               title: "Manage Users",
               headline: "Black Page",
            },
            menuItems: [
               {title: "Only Show Active Accounts", value: true}
            ],
         };
      },
      methods:{



         //used by edit form
         async on_org_change(){
            this.dealers = await this.get_dealers({org_id: this.editedItem.org_ids});
         },

         on_acct_change() {

            if (this.editedItem.acct_type == 'AGENCY'){
               this.userRoles = this.userRoles_a;
               this.multiple_orgs = true;
            }
            else if  (this.editedItem.acct_type == 'CLIENT'){
               this.userRoles = this.userRoles_c;
               this.multiple_orgs = false;
            }
            else {
               console.log('Error: account type not recognized')
            }

            if (!this.userRoles.includes(this.editedItem.role) )
               this.editedItem.role = null

         },

         on_role_change() {

            if (!['SalesPerson', 'Manager'].includes(this.editedItem.role) ) {
               this.editedItem.sp_level = null;
            }

         },


         //******************main page controls********************************************************************
         //
         async update_orgs_main(){

            let query ={};
            if (this.showOnlyActive){
               query.is_active = true;
            }else{
               query.is_active = null;
            }


            let data = await this.get_organizations(query);
            this.organizations = data.sort((a, b) => (a.name > b.name) ? 1 : -1);

            if (!this.showOnlyActive){
               this.organizations.map((x)=>{
                  if (!x.is_active) x.name = x.name + ' (inactive)';
                  return x;
               })
            }
            this.orgs2 = [...this.organizations]; //make a copy


            if (this.$auth.profile.acct_type === 'AGENCY'){
               this.orgs2.unshift({_id: null, name: 'AGENCY'});
            }


         },

         //used by main org dropdown on page
         async on_org_change_main(){
            this.get_users_local();

            let query ={};
            if (this.showOnlyActive){
               query.is_active = true;
            }else{
               query.is_active = null;
            }
            query.org_id = this.selectedOrg;

            let data = await this.get_dealers(query);
            if (!this.showOnlyActive){
               data.map((x)=>{
                  if (!x.is_active) x.name = x.name + ' (inactive)';
                  return x;
               })
            }
            this.dealers_main = data.sort((a, b) => (a.name > b.name) ? 1 : -1);
            this.dealers_main.unshift({_id: null, name: 'All Dealerships'});

            this.selectedDealerId = null;

         },



         async get_users_local(){
            this.getting_users = true;

            let query ={};
            if (this.showOnlyActive){
               query.is_active = true;
            }

            if (this.selectedOrg === null){
               query.acct_type = 'AGENCY';
            }
            else{
               query.org_id = this.selectedOrg;
            }


            if (this.selectedDealerId !== null){
               query.dealer_id = this.selectedDealerId;
            }

            this.users = await this.get_users(query);
            this.users.sort((a, b) => a.name > b.name ? 1: -1);
            this.getting_users = false;
         },

         //******download data*********************

         async download_users(){



            try{
               let save_name = 'users_data.csv';

               let query ={};
               if (this.showOnlyActive){
                  query.is_active = true;
               }

               if (this.selectedOrg === null){
                  query.acct_type = 'AGENCY';
               }
               else{
                  query.org_id = this.selectedOrg;
               }


               if (this.selectedDealerId !== null){
                  query.dealer_id = this.selectedDealerId;
               }


               query.asCsv = true;
               let data = await this.get_users(query);


               // let res = await this.get_graded_leads_csv({dateRange});

               const url = URL.createObjectURL(new Blob([data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', save_name );
               document.body.appendChild(link);
               link.click();
               // this.dialog_download=false;
            }
            catch(err){
               this.show_error_details(err, 'download_users()')
            }


         },


         //global user search
         async get_users_search(){
            try{
               this.is_searching = true;
               this.users = await this.get_users({email: this.g_search_txt});

               this.selectedOrg = 'Search Results';
               this.form_error_search = null;
               this.dialog_search = false;

            }
            catch(err){
               this.form_error_search = this.show_error_details(err, 'get_users_search()');

            }
            this.is_searching = false;

         },


         open_g_search(){
            this.dialog_search=true;

            //see https://forum.vuejs.org/t/how-to-set-focus-to-input/10672/7
            this.$nextTick(() => this.$refs.global_search_box.focus())
         },

         gen_password(n = 12){
            let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890!@#$%^&*';
            let chars_n = chars.length-1;
            let rnd = new Uint8Array(n);
            let ans = '';
            //note #'s in rnd are between 0 and 2^8 - 1
            window.crypto.getRandomValues(rnd);

            //scales numbers to between 0 and chars_n
            let max = 255; //2^8 - 1
            for (let i=0; i< n; i++){
               if (i < 2)
                  rnd[i] = Math.round(rnd[i]/max * 52); //for first 2 chars get a letter
               else
                  rnd[i] = Math.round(rnd[i]/max * chars_n);
               ans += chars[rnd[i]];
            }

            console.log(rnd)
            console.log(ans)
            return ans;

         },

         /**
          * generates a password that is guaranteed to have at least one
          * upper char, lower char, number, and special char
          */
         gen_password_checked(n=12){
            let stop = false;
            let ans = '';
            let upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
            let lower = 'abcdefghijklmnopqrstuvwxyz'.split('');
            let nums = '1234567890'.split('');
            let special = '!@#$%^&*'.split('');

            let i = 0;

            while (!stop && i < 100){
               ans = this.gen_password(n);

               let a_ans = ans.split('');

               let intersection = a_ans.filter(x => upper.includes(x));
               let bu = intersection.length > 0;

               intersection = a_ans.filter(x => lower.includes(x));
               let bl = intersection.length > 0;

               intersection = a_ans.filter(x => nums.includes(x));
               let bn = intersection.length > 0;

               intersection = a_ans.filter(x => special.includes(x));
               let bs = intersection.length > 0;

               stop = bu && bl && bn && bs;
               i++;

            }
            this.editedItem.password = ans;

         },

         //*************************************************************************************************************
         close () {
            this.dialog = false;
            setTimeout(() => {
               this.editedItem = Object.assign({}, form);
               this.editedIndex = -1;
               this.newUser = true;
               this.dealers = [];
               this.formTitle='Add New User';
               this.$refs.form.resetValidation();
               this.form_error = null;
               this.enable_org_change = true;
               this.enable_dealer_change = true;
            }, 300)
         },

         //*************************************************************************************************************
         async save () {


            if (this.$refs.form.validate()) {
               //create copy of data to push to api
               let post_data = JSON.parse(JSON.stringify(this.editedItem));


               if (typeof  post_data.org_ids === 'string'){
                  post_data.org_ids = [post_data.org_ids]; // turn into array
               }

               if (typeof  post_data.dealership_ids === 'string'){
                  post_data.dealership_ids = [post_data.dealership_ids]; // turn into array
               }



               //  if account is an agency account
               if (this.editedItem.acct_type === 'AGENCY'){
                  post_data.dealership_ids = null;


                  if (['SuperAdmin', 'Admin'].includes(this.editedItem.role) ){
                     post_data.org_ids = null;
                  }
               }

               // if account is a CLIENT account
               else if (this.editedItem.acct_type === 'CLIENT') {
                  post_data.include_on_comments_internal = null;
                  if (['Admin'].includes(this.editedItem.role) ){
                     post_data.dealership_ids = null;
                  }

               }

               delete post_data.include_on_emails;

               console.log(post_data);

               //save to server
               let res;
               try {
                  // console.log(post_data);
                  let token = await this.$auth.getAxiosHeader();

                  if (this.newUser){
                     let url = this.$baseUrlApi + '/createUser';
                     res = await axios.post(url, post_data, token);

                  }
                  else{
                     post_data.user_id = this.editedItem.user_id;
                     let url = this.$baseUrlApi + '/updateUser';
                     res = await axios.post(url, post_data, token);
                  }

                  // console.log('I ran!')
                  // update data
                  this.get_users_local();
                  this.close();
               }
               catch(err){
                  this.form_error = this.show_error_details(err, 'save() on ManageUser page');
               }
            }// if form is valid
            else{
               this.form_error = 'Please check highlighted fields'
            }




         },

         //*************************************************************************************************************
         /**
          * populates form based on user selected to edit
          * @param item - an element in this.users array
          */
         editItem (item) {
            this.editedItem =  {
               user_id: item.user_id,
               acct_type: item.app_metadata.acct_type,
               agency_id: item.app_metadata.agency_id,
               org_ids: [],
               dealership_ids: [],
               name_first: item.given_name,
               name_last: item.family_name,
               role: item.app_metadata.role,
               email: item.email,
               include_on_grades: item.app_metadata.include_on_grades,
               include_on_pdf_reports: item.app_metadata.include_on_pdf_reports,
               include_on_pdf_reports_sp: item.app_metadata.include_on_pdf_reports_sp,
               include_on_pdf_reports_org: item.app_metadata.include_on_pdf_reports_org,
               include_on_comments_internal: item.app_metadata.include_on_comments_internal,

               include_on_coachup: item.app_metadata.include_on_coachup,
               include_on_pdf_reports_coachup: item.app_metadata.include_on_pdf_reports_coachup,

               sp_level: item.app_metadata.curriculum_level,
               is_active: item.app_metadata.is_active,
               title: item.app_metadata.title
            };
            console.log({item})

            this.enable_org_change = false;
            this.enable_dealer_change = false;

            //strip added info about dealerships
            let n = item.app_metadata.dealership_ids.length;
            for (let i=0; i<n; i++){
               this.editedItem.dealership_ids.push(item.app_metadata.dealership_ids[i]._id)
            }

            //strip added info about orgs
            n = item.app_metadata.org_ids.length;
            for (let i=0; i<n; i++){
               this.editedItem.org_ids.push(item.app_metadata.org_ids[i]._id)
            }

            // if a client account, then replace array with single object, since the selector is expecting a single value
            if (this.editedItem.acct_type ==='CLIENT')
               this.editedItem.org_ids = this.editedItem.org_ids[0];

            //update data based on form values
            this.on_acct_change();
            this.on_role_change();
            this.on_org_change();


            if (!Array.isArray(this.editedItem.org_ids))
                this.get_dealers({org_id: this.editedItem.org_ids});
                // if org_ids is an array then account is an agency acct, which means that dealership can't/won't be selected

            this.newUser = false;
            this.formTitle='Edit User Profile';
            this.dialog = true
         },

         new_user(){
            this.editedItem.agency_id = this.$auth.profile.agency_id;
            this.dialog = true;
         },

         //*************************************************************************************************************
         deleteItem (item) {
            const index = this.dealers.indexOf(item);
            confirm('Are you sure you want to delete this item?') && this.dealers.splice(index, 1)
         },

      }, //methods

      computed: {
         disable_sp_level(){
            if (['SalesPerson', 'Manager'].includes(this.editedItem.role)  && this.editedItem.acct_type==='CLIENT')
               return false;
            else
               return true;
         },

         disable_sp_level_validation(){

            if (['SalesPerson'].includes(this.editedItem.role)  && this.editedItem.acct_type==='CLIENT')
               return false;
            else
               return true;
         },


         disable_dealer_check() {
            if (this.editedItem.acct_type === 'AGENCY' || this.editedItem.role === 'Admin' || this.editedItem.acct_type === '') {
               return true;
            }
            else{
               return false;
            }
         },

         disable_dealer_select(){
            if (this.editedItem.acct_type === 'AGENCY' ||  this.editedItem.role === 'Admin' || this.editedItem.acct_type=== ''){
               return true;
            }
            else{
               return !this.enable_dealer_change;
            }
         },


         disable_title(){
            return !(this.editedItem.acct_type === 'CLIENT');
         },


         disable_orgs_check(){
            return !(this.editedItem.acct_type === 'CLIENT');

         },
         disable_orgs(){
            // return !(this.editedItem.acct_type === 'CLIENT');

            if (this.editedItem.acct_type !== 'CLIENT') {
               return true;
            }
            else {
               return !this.enable_org_change;
            }
         },

         disable_comments_internal(){
           return (this.editedItem.acct_type !== 'AGENCY' || this.editedItem.role === 'Grader');

         },


         disable_pdf_reports(){
            return false;
         },

         isClient(){
            return this.editedItem.acct_type === 'CLIENT';
         },

         isSalesPerson(){
            return this.editedItem.role === 'SalesPerson';
         },

         isManager(){
            return ['Admin', 'Manager'].includes(this.editedItem.role);
         },




         disable_include_on_grades(){
            return false;
            // return  ( [ 'Grader', 'SalesPerson'].includes(this.editedItem.role));


         },

         user_titles(){
            let ans=[];

            if (this.editedItem.acct_type === 'CLIENT'){

               if ( ['Admin', 'Executive', ].includes(this.editedItem.role)){
                  ans = ['Owner', 'GM', 'GSM', ];
               }
               else if  (this.editedItem.role === 'Manager'){
                  ans = ['GM', 'GSM', 'Sales Manager'];
               }

               else if  (this.editedItem.role === 'SalesPerson'){
                  ans = ['Sales Person', 'ISM', 'BDC'];
               }

            }

            return ans;
         },


      }, // computed object

      async created(){
         // this.users         = await this.get_users();
         // this.agencies      = await this.get_agencies();
         // this.organizations = await this.get_organizations();

         // this.get_users().then(data =>{
         //    this.users = data;
         // });



         this.get_agencies().then(data =>{
            this.agencies = data;
         });

         await this.update_orgs_main();
         if (this.$auth.profile.acct_type === 'AGENCY'){
            this.selectedOrg = null;
         }
         else{
            this.selectedOrg = this.$auth.profile.org_ids[0];
         }
         await this.on_org_change_main();
         this.get_users_local();

      }



   };
</script>
